export async function getMemberSelfBalance(base, signal) {
    const response = await fetch(`${base.replace(/\/$/, '')}/identity/member-self/balance`, {
        credentials: 'include',
        signal: signal ?? null,
        headers: { Accept: 'application/json' },
    });
    const body = await response.json();
    if (!response.ok)
        throw new Error(body.message ?? 'No se pudo consultar tu saldo.');
    return body;
}
export async function provisionMemberAccounts(base) {
    const response = await fetch(`${base.replace(/\/$/, '')}/identity/member-accounts/provision`, {
        method: 'POST',
        credentials: 'include',
        headers: { Accept: 'application/json' },
    });
    const body = await response.json();
    if (!response.ok)
        throw new Error(body.message ?? 'No se pudieron preparar las cuentas.');
    return body;
}
